import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useAppStateStore = defineStore('appState', () => {
  const preloaded = ref(false)
  const loadingState = ref(false)

  const updateLoadingState = (updateState: boolean) => (loadingState.value = updateState)

  const updatePreloadState = (updateState: boolean) => (preloaded.value = updateState)

  return {
    loadingState,
    preloaded,
    updateLoadingState,
    updatePreloadState,
  }
})
